import recruiterApi from "api/recruiter";
import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import {handleError} from "helpers/errors";
import {AwaitableModal} from "hooks/useAwaitableModal";
import {useState} from "react";

interface Props {
  street1: string;
  street2?: string;
  city: string;
  state: string;
  country: string;
}

const EditAddress: AwaitableModal<Props, Props> = ({initialData, open, onCancel, resolve}) => {
  const [street1, setStreet1] = useState(initialData.street1);
  const [street2, setStreet2] = useState(initialData.street2);
  const [city, setCity] = useState(initialData.city);
  const [state, setState] = useState(initialData.state);
  const [country, setCountry] = useState(initialData.country);
  const [submitting, setSubmitting] = useState(false);

  const onEdit = () => {
    if (submitting) return;
    if (!street1) return handleError("Please enter the street address");
    if (!city) return handleError("Please enter the city");
    if (!state) return handleError("Please enter the state");
    if (!country) return handleError("Please enter the country");
    setSubmitting(true);
    recruiterApi
      .updateAddress({street1, street2, city, country, state})
      .then(() => resolve({street1, street2, city, country, state}))
      .finally(() => setSubmitting(false));
  };

  return (
    <Modal open={open} close={!submitting ? onCancel : () => {}}>
      <ModalLayout
        title="Edit Company Address"
        footer={
          <>
            <button className="btn-secondary" disabled={submitting} onClick={onCancel}>
              Cancel
            </button>
            <button className="btn-primary" disabled={submitting} onClick={onEdit}>
              Save Changes
            </button>
          </>
        }
      >
        <input
          type="text"
          placeholder="Address Line 1"
          value={street1}
          onChange={(e) => setStreet1(e.currentTarget.value)}
        />
        <input
          type="text"
          placeholder="Address Line 2 (optional)"
          value={street2}
          onChange={(e) => setStreet2(e.currentTarget.value)}
        />
        <input type="text" placeholder="City" value={city} onChange={(e) => setCity(e.currentTarget.value)} />
        <input type="text" placeholder="State" value={state} onChange={(e) => setState(e.currentTarget.value)} />
        <input type="text" placeholder="Country" value={country} onChange={(e) => setCountry(e.currentTarget.value)} />
      </ModalLayout>
    </Modal>
  );
};

export default EditAddress;
